import { render } from "./RealizarAssinaturaDeclaracao.vue?vue&type=template&id=b42a9ffe&scoped=true"
import script from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"
export * from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"

import "./RealizarAssinaturaDeclaracao.vue?vue&type=style&index=0&id=b42a9ffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42a9ffe"]])

export default __exports__